document.addEventListener('DOMContentLoaded', () => {
    $(() => {
        svg4everybody();

        window.lazyload = new LazyLoad();

        $('.about__slider').slick({
            infinite: false,
            variableWidth: true,
            slidesToShow: 2,
            prevArrow: $('.about__nav-btn_left'),
            nextArrow: $('.about__nav-btn_right'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ]
        });

        $('.reviews__slider').slick({
            infinite: false,
            variableWidth: true,
            prevArrow: $('.reviews__nav-btn_left'),
            nextArrow: $('.reviews__nav-btn_right'),
        });

        $('.choose-model__slider').slick({
            infinite: false,
            slidesToShow: 5,
            prevArrow: $('.about__nav-btn_left'),
            nextArrow: $('.about__nav-btn_right'),
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 6,
                    },
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ]
        });

        $('.articles__slider').slick({
            infinite: false,
            variableWidth: true,
            slidesToShow: 2,
            prevArrow: $('.articles__nav-btn_left'),
            nextArrow: $('.articles__nav-btn_right'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ]
        });

        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
    })
});
